import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TeamGroupModel } from 'flux-user';

@Component({
    selector: 'team-group-list-item',
    templateUrl: './team-group-list-item.cmp.html',
    styleUrls: [ './team-group-list-item.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * This component is used to encapsulate functionality such as
 * displaying and removing a team group from the team group
 * list in the project / diagram share window. A collabortator
 * can be added by using the <team-group-list-item></team-group-list-item>
 * selector.
 */
export class TeamGroupListItem {

    /**
     * Input teamGroup from the team's group array
     */
    @Input()
    public teamGroup: TeamGroupModel;

    @Output()
    public itemSelected: EventEmitter<TeamGroupModel>;

    constructor() {
        this.itemSelected = new EventEmitter();
    }

    public onClickEvent() {
        this.itemSelected.emit( this.teamGroup );
    }
}
